import { AppComponent } from './app.component';

import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class MyHttpInterceptorService implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    console.log("inside interceptor");
    // add a custom header
    const customReq = request.clone({
      //headers: request.headers.set('Authorization', "Basic "+btoa("butter:butter123"))
     // headers: request.headers.set('Device-Id', AppModule.DEVICE_ID)
     //headers: request.headers.set('Authorization', "Basic "+btoa(1+":"+1))
      headers: request.headers.set('Authorization', "Basic "+btoa(AppComponent.user.username+":"+AppComponent.user.password))
     // headers: request.headers.set('Authorization', "Basic "+btoa("1:1"))
    });

    return next.handle(customReq);
  }
}



// WEBPACK FOOTER //
// ./src/app/my-http-interceptor.service.ts